import { Input, message } from "antd";
import { useTranslation } from "react-i18next";

interface InputNameProps {
  maxLength: number;
  autoComplete?: string;
  placeholder?: string;
  onChange?: (value: string) => void;
}

const InputName: React.FC<InputNameProps> = ({ maxLength, ...rest }) => {
  const [t] = useTranslation("common");
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    if (value.length <= maxLength) {
      rest.onChange?.(value);
    } else {
      message.warning("Maximum length reached!");
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  return (
    <Input
      {...rest}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      placeholder={`${t("enter-text")}`}
      autoComplete="off"
    />
  );
};

export default InputName;
